import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faCopy,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Link, NavLink } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./QuestionnaireElement.css";

function QuestionnaireElement({
  id,
  title,
  title_english,
  description,
  description_english,
  language,
  type,
  role,
  handleShow,
}) {
  const { t } = useTranslation();

  return (
    <Row className="questionnaire-element align-items-center">
      <Col lg={9} className="questionnaire-element-header">
        {(type === "traumatic" ||
          type === "psychosocial" ||
          type === "environment") &&
        role !== "root" ? (
          <h5>{language === "es" ? title : title_english}</h5>
        ) : (
          <NavLink className="nav-link" to={`/questionnaire/${id}`}>
            <h5>{language === "es" ? title : title_english}</h5>
          </NavLink>
        )}

        <p>{language === "es" ? description : description_english}</p>
      </Col>
      <Col lg={3} className="questionnaire-element-content">
        {role === "root" ? (
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <FontAwesomeIcon icon={faCog} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item as={Link} to={`/questionnaires/edit/${id}`}>
                <FontAwesomeIcon icon={faEdit} />{" "}
                {t("Cuestionarios.Cuestionario.Editar")}
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={`/questionnaires/delete/${id}`}>
                <FontAwesomeIcon icon={faTrash} />{" "}
                {t("Cuestionarios.Cuestionario.Eliminar")}
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleShow(id)}>
                <FontAwesomeIcon icon={faCopy} /> Clonar
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ) : type === "traumatic" ||
          type === "psychosocial" ||
          type === "environment" ? (
          <></>
        ) : (
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <FontAwesomeIcon icon={faCog} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item as={Link} to={`/questionnaires/edit/${id}`}>
                <FontAwesomeIcon icon={faEdit} />
                {t("Cuestionarios.Cuestionario.Editar")}
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={`/questionnaires/delete/${id}`}>
                <FontAwesomeIcon icon={faTrash} />
                {t("Cuestionarios.Cuestionario.Eliminar")}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </Col>
    </Row>
  );
}

export default QuestionnaireElement;
